// SETTINGS V2 atom — SErrorCallout. The section-standard "added error state"
// (fix+flag pattern). Amber inline callout. Port of settings-kit.jsx
// SErrorCallout (lines 127-142). SP4+ consumes it heavily; SP0 ships it as part
// of the kit. Caller passes already-translated strings (atoms never translate).
import React from "react";

import SettingsV2Tooltip from "./SettingsV2Tooltip";

export interface SErrorCalloutProps {
  title: string;
  body?: string;
  actionLabel?: string;
  onAction?: () => void;
  /** Optional hover tooltip on the action button (already-translated text). */
  actionTooltip?: string;
}

const SErrorCallout: React.FC<SErrorCalloutProps> = ({
  title,
  body,
  actionLabel,
  onAction,
  actionTooltip,
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "10px 12px",
      borderRadius: 8,
      background: "color-mix(in oklab, var(--amber) 12%, var(--card))",
      border: "1px solid color-mix(in oklab, var(--amber) 40%, var(--border))",
    }}
  >
    <span style={{ color: "var(--amber)", fontSize: 15 }}>⚠</span>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--ink)" }}>
        {title}
      </div>
      {body && (
        <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 1 }}>
          {body}
        </div>
      )}
    </div>
    {actionLabel &&
      (actionTooltip ? (
        <SettingsV2Tooltip text={actionTooltip}>
          <button
            type="button"
            className="btn"
            onClick={onAction}
            style={{ whiteSpace: "nowrap" }}
          >
            {actionLabel}
          </button>
        </SettingsV2Tooltip>
      ) : (
        <button
          type="button"
          className="btn"
          onClick={onAction}
          style={{ whiteSpace: "nowrap" }}
        >
          {actionLabel}
        </button>
      ))}
  </div>
);

export default SErrorCallout;
